(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'
  }).format(cents / 100);
  const init = (root) => {
    if (root.dataset.upsellReady) return;
    root.dataset.upsellReady = 'true';
    const i18nEl = root.querySelector('[data-burn-upsell-i18n]');
    let i18n = {};
    try { i18n = i18nEl ? JSON.parse(i18nEl.textContent) || {} : {}; } catch (e) { i18n = {}; }
    const L = (key, fallback) => i18n[key] || fallback;
    root.querySelectorAll('[data-upsell-card]').forEach((card) => {
      const product = JSON.parse(card.querySelector('[data-upsell-product]').textContent);
      const form = card.querySelector('[data-upsell-form]');
      const select = card.querySelector('[data-upsell-variant]');
      const button = card.querySelector('[data-upsell-add]');
      const price = card.querySelector('[data-upsell-price]');
      const status = card.querySelector('[data-upsell-status]');
      const image = card.querySelector('.burn-upsell__image img');
      const initialImage = image?.getAttribute('src');
      let busy = false;
      const variant = () => product.variants.find((item) => String(item.id) === select.value);
      const update = () => {
        const selected = variant();
        price.textContent = selected ? money(selected.price) : '—';
        button.disabled = busy || !selected?.available;
        button.textContent = busy ? L('adding', 'Ajout en cours…') : selected?.available ? L('add', 'Ajouter au panier') : L('unavailable', 'Indisponible');
        const source = selected?.featured_image?.src || initialImage;
        if (image && source) {
          image.removeAttribute('srcset');
          image.src = source;
        }
      };
      select.addEventListener('change', () => {
        status.textContent = '';
        status.classList.remove('is-error');
        update();
      });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const selected = variant();
        if (busy || !selected?.available) return;
        busy = true;
        button.setAttribute('aria-busy', 'true');
        select.disabled = true;
        status.textContent = '';
        status.classList.remove('is-error');
        update();
        try {
          const base = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${base}cart/add.js`, {
            method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
            body:JSON.stringify({items:[{id:selected.id,quantity:1}]})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || L('add_error', 'Ajout impossible. Réessayez.'));
          // An add can succeed even when the subsequent cart refresh fails.
          // Keep the confirmed success to avoid prompting a duplicate add.
          status.textContent = L('added_product', '__TITLE__ ajouté au panier.').replace('__TITLE__', product.title);
          button.textContent = L('added_short', 'Ajouté ✓');
          try {
            const cartResponse = await fetch(`${base}cart.js`, {headers:{Accept:'application/json'}});
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles:true, detail:{baseEvent:'variant:add',cart}
              }));
            }
          } catch (_) { /* The add is already confirmed; the cart page remains available. */ }
          form.dispatchEvent(new CustomEvent('variant:add', {bubbles:true,detail:{items:result.items || result}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        } catch (error) {
          status.textContent = error.message || L('add_error', 'Ajout impossible. Réessayez.');
          status.classList.add('is-error');
        } finally {
          busy = false;
          select.disabled = false;
          button.removeAttribute('aria-busy');
          update();
        }
      });
      update();
    });
  };
  const scan = () => document.querySelectorAll('[data-burn-upsell]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan); else scan();
  document.addEventListener('shopify:section:load',scan);
})();
